import React from "react";

interface Props {
  value: number;
  value2?: number;
  max?: number;
  type: string;
  lang: string;
}

const SurveyBadge: React.FC<Props> = (props: Props) => {

  let cls = "z-badge zb-";
  let text: string;
  let colorVal: number;

  if (props.type === "score") {
    if (props.value > 0.88) {
      text = props.lang === "sv" ? "Mycket hög" : "Very high";
      colorVal = 4;
    } else if (props.value > 0.76) {
      text = props.lang === "sv" ? "Hög" : "High";
      colorVal = 3;
    } else if (props.value > 0.6) {
      text = props.lang === "sv" ? "Måttlig" : "Moderate";
      colorVal = 2;
    } else {
      text = props.lang === "sv" ? "Låg" : "Low";
      colorVal = 1;
    }
  } else if (props.type === "gap") {
    if (props.value > 1.2) {
      text = props.lang === "sv" ? "Stort" : "Large";
      colorVal = 1;
    } else if (props.value > 0.8) {
      text = props.lang === "sv" ? "Tydligt" : "Clear";
      colorVal = 2;
    } else if (props.value > 0.4) {
      text = props.lang === "sv" ? "Märkbar" : "Noticeable";
      colorVal = 3;
    } else {
      text = props.lang === "sv" ? "Litet" : "Small";
      colorVal = 4;
    }
  } else if (props.type === "feedback_alignment") {
    if (props.value > 0.75) {
      text = props.lang === "sv" ? "Mycket hög" : "Very high";
      colorVal = 4;
    } else if (props.value > 0.5) {
      text = props.lang === "sv" ? "Hög" : "High";
      colorVal = 3;
    } else if (props.value > 0.25) {
      text = props.lang === "sv" ? "Blandad" : "Mixed";
      colorVal = 2;
    } else if (props.value >= 0) {
      text = props.lang === "sv" ? "Låg" : "Low";
      colorVal = 1;
    } else {
      text = "N/A";
      colorVal = 1;
    }
  } else if (props.type === "validated" && props.value2) {
    let limit = 4;
    if (props.max) {
      if (props.max === 10) {
        limit = 8;
      } else if (props.max === 7) {
        limit = 6;
      } else if (props.max === 3) {
        limit = 2;
      }
    }
    if (props.value2 >= limit) {
      if (props.value >= limit) {
        text = props.lang === "sv" ? "Validerad styrka" : "Validated strength";
        colorVal = 4;
      } else {
        text = props.lang === "sv" ? "Dold styrka" : "Hidden strength";
        colorVal = 3;
      }
    } else {
      if (props.value >= limit) {
        text = props.lang === "sv" ? "Blinda fält" : "Blind spot";
        colorVal = 2;
      } else {
        text = props.lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
        colorVal = 1;
      }
    }
  } else if (props.type === "self_only") {
    let limit = 4;
    if (props.max) {
      if (props.max === 10) {
        limit = 8;
      } else if (props.max === 7) {
        limit = 6;
      } else if (props.max === 3) {
        limit = 2;
      }
    }
    if (props.value >= limit) {
      text = props.lang === "sv" ? "Styrka" : "Strength";
      colorVal = 4;
    } else {
      text = props.lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
      colorVal = 1;
    }
  } else {
    text = "Unknown";
    colorVal = 1;
  }

  cls += colorVal;

  return (
    <div className={cls} title={text}>
      {text}
    </div>
  );
};

export default SurveyBadge;
